import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { LookInside } from './components/LookInside';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductShowcase } from './components/ProductShowcase';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-slate-50 text-teal-950 selection:bg-amber-300 selection:text-teal-950" data-id="element-0" data-mp="28ufpyg1ohml6">
      <MetaPixel data-id="element-1" data-mp="23w4clvc6cty7" />
      <main data-id="element-2" data-mp="23ujho4ly78zt">
        <Hero data-id="element-3" data-mp="23v2rsz5cwt3a" />
        <ProblemSolution data-id="element-4" data-mp="23ti8y6semyl9" />
        <ProductShowcase data-id="element-5" data-mp="3ik7k0rkruvvx" />
        <Volumes data-id="element-6" data-mp="3iiwfuqnezm4a" />
        <LookInside data-id="element-7" data-mp="3ijfu9xduvsdk" />
        <Bonuses data-id="element-8" data-mp="3ihuyy5jpw5en" />
        <Pricing id="offer" titleId="offer-title" data-id="element-9" data-mp="3mlj6io8cn0zw" />
        <Differentiators data-id="element-10" data-mp="3mjzs7369700r" />
        <Testimonials data-id="element-11" data-mp="3mj6ibtbzzuee" />
        <Faq data-id="element-12" data-mp="3rcj7c4kla37o" />
        <FinalClose data-id="element-13" data-mp="3rbzmog3k10py" />
      </main>
      <Footer data-id="element-14" data-mp="3rcswxr1q28cu" />
      <PurchasePopup data-id="element-15" data-mp="3recedkz46pg7" />
      <noscript data-id="element-16" data-mp="5yhgo69t1c8">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-17" data-mp="6hq1ea16ddl" />
      </noscript>
    </div>;
}